import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { connect } from 'react-redux';
import EventInfo from '~/components/EventInfo';
import VenueInfo from '~/components/VenueInfo';
import { getEvent } from '~/selectors/event';
const ExpiredEventScreen = ({ event }) => {
    return (_jsxs(_Fragment, { children: [_jsx(EventInfo, { eventData: event, expiredEventScreen: true }), _jsx(VenueInfo, {})] }));
};
const mapStateToProps = (state) => ({
    event: getEvent(state),
});
export default connect(mapStateToProps)(ExpiredEventScreen);
